import { DateRange } from 'react-day-picker';
import { format } from 'date-fns';
import { BASE_URL } from '@/config/api';
import { InvoiceReportData } from '@/pages/InvoiceReport';

// Generate mock data for development
const generateMockReportData = (dateRange?: DateRange): InvoiceReportData => {
  const currentYear = new Date().getFullYear();
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const monthlyData = months.map((month, index) => {
    const revenue = Math.floor(Math.random() * 5000) + 1000;
    const paid = Math.floor(revenue * (Math.random() * 0.4 + 0.5)); // 50-90% paid
    const pending = revenue - paid;
    const count = Math.floor(Math.random() * 20) + 5;
    
    return {
      month,
      revenue,
      paid,
      pending,
      count
    };
  });
  
  const totalRevenue = monthlyData.reduce((sum, month) => sum + month.revenue, 0);
  const totalPaid = monthlyData.reduce((sum, month) => sum + month.paid, 0);
  const totalPending = totalRevenue - totalPaid;
  const totalInvoices = monthlyData.reduce((sum, month) => sum + month.count, 0);
  
  return {
    summary: {
      totalRevenue,
      totalPaid,
      totalPending,
      totalInvoices
    },
    monthly: monthlyData,
    paymentMethods: {
      card: Math.floor(totalPaid * 0.7), // 70% paid by card
      cash: Math.floor(totalPaid * 0.3), // 30% paid by cash
      pending: totalPending
    },
    topStudents: [
      { id: '1', name: 'John Smith', totalSpent: 2540.50, invoiceCount: 12 },
      { id: '2', name: 'Emma Johnson', totalSpent: 1820.75, invoiceCount: 8 },
      { id: '3', name: 'Michael Brown', totalSpent: 1650.25, invoiceCount: 7 },
      { id: '4', name: 'Sophia Williams', totalSpent: 1200.00, invoiceCount: 6 },
      { id: '5', name: 'James Davis', totalSpent: 980.50, invoiceCount: 4 },
    ]
  };
};

// Fetch invoice report from API (currently returns mock data)
export const fetchInvoiceReport = async (dateRange?: DateRange): Promise<InvoiceReportData> => {
    try {
      const response = await fetch(`${BASE_URL}/api/invoices/getReport`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('auth-token')}`
        },
        body: JSON.stringify({
          dateFrom: dateRange?.from ? format(dateRange.from, 'yyyy-MM-dd') : undefined,
          dateTo: dateRange?.to ? format(dateRange.to, 'yyyy-MM-dd') : undefined
        })
      });
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching invoice report:', error);
      throw new Error('Failed to fetch invoice report data.');
    }
  };

// Save invoice report
export const saveInvoiceReport = async (params: { 
  data: InvoiceReportData, 
  dateRange?: DateRange,
  userId: string 
}): Promise<void> => {
  try {
    // In the future, this will be a real API call
    // const response = await fetch(`${BASE_URL}/api/invoices/saveReport`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${localStorage.getItem('auth-token')}`
    //   },
    //   body: JSON.stringify({
    //     reportData: params.data,
    //     dateFrom: params.dateRange?.from ? format(params.dateRange.from, 'yyyy-MM-dd') : undefined,
    //     dateTo: params.dateRange?.to ? format(params.dateRange.to, 'yyyy-MM-dd') : undefined,
    //     userId: params.userId
    //   })
    // });
    // return await response.json();

    // For now, simulate a successful API call
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Report saved:', params);
        resolve();
      }, 1000); // Simulate network delay
    });
  } catch (error) {
    console.error('Error saving invoice report:', error);
    throw new Error('Failed to save invoice report.');
  }
};